module.exports = __webpack_public_path__ + "img/popupAd-day2.622e09e7.png";